"use client";

import * as React from "react";
import styled from "styled-components";
import defaultTheme from "../defaultTheme";
import getViewportHideStyles from "./helpers/getViewportHideStyles";
import getDisplay from "./helpers/getDisplay";
const StyledHide = styled.div.withConfig({
  displayName: "Hide__StyledHide",
  componentId: "sc-1ilbsf3-0"
})(["", ";"], ({
  $on
}) => getViewportHideStyles($on, getDisplay));
StyledHide.defaultProps = {
  theme: defaultTheme
};
const Hide = ({
  on = [],
  block,
  children
}) => /*#__PURE__*/React.createElement(StyledHide, {
  $on: on,
  $block: block
}, children);
export default Hide;